export * from './delete-rolle-request.interface';
export * from './delete-rolle-response.interface';
export * from './delete-rolle.shapes';
